import { SelectOptionModel } from "@app/incident/components/src/lib/core/models/select-option.model";
import { Observable } from "rxjs";

export abstract class BaseDocumentsService {
    abstract getDocumentTypes(): Observable<SelectOptionModel[]>;
    abstract getDocumentIcon(fileName: string): string;
    abstract getDocumentConfig(): Observable<{
        maxUploadSizeInMb: number;
        allowedFileExtensions: string;
    }>;
    abstract getDocumentHistory(documentId: string): Observable<any>;
    abstract filterAllowedFiles(files: File[] | FileList, allowedExtensions: string): File[];
    abstract validateUploadLimit(files: File[], maxUploadSizeInMb: number): boolean;
    abstract openDocumentViewer(documentId: string, documentName: string, pdfSrc?: string): void;
}
